import { useEffect, useState } from 'react';
import propriedadeAvaliacaoService from '../../../../service/PropriedadeAvaliacaoService';

function usePerguntas(type, group = false) {
    const [perguntas, setPerguntas] = useState(group ? {} : []);
    useEffect(() => {
        const init = async () => {
            const response = await propriedadeAvaliacaoService.list({
                params: {
                    search: `tipoPropriedadeAvaliacao.codgTipoPropriedade==${type}`,
                },
            });
            if (group) {
                setPerguntas(
                    response.reduce((prev, current) => {
                        prev[current.grupoPropriedadeAvaliacao.codgGrupoPropriedadeAva] = [
                            ...(prev?.[current.grupoPropriedadeAvaliacao.codgGrupoPropriedadeAva] ??
                                []),
                            current,
                        ];
                        return prev;
                    }, {})
                );
            } else {
                setPerguntas(response);
            }
        };
        init();
    }, []);
    return perguntas;
}

export { usePerguntas };
